<aur-drawer (visibleChange)="visibleChange($event)" [baseZIndex]="1099" #drawer>
  <header>
    <h2>
      {{'ARC_CONFIGURATION_SETTINGS_SYSTEM_SETTINGS_LABEL' | translate}}
    </h2>
    <aur-dropdown [options]="settingSections" optionLabel="label" [(ngModel)]="activeSection" [style]="{ 'width': '200px' }"></aur-dropdown>
  </header>
  <!-- drawer body content goes here -->
  <aur-card *ngIf="drawerDrawn && (activeSection?.id === 'btnSSOConfiguration')">
    <arc-configuration-sso-container (saved)="ssoSaved($event)" (canceled)="ssoCanceled($event)"></arc-configuration-sso-container>
  </aur-card>
  <aur-card *ngIf="drawerDrawn && (activeSection?.id === 'btnCreditCardProcessingConfiguration')">
    <pay-card-processing></pay-card-processing>
  </aur-card>
  <aur-card *ngIf="drawerDrawn && (activeSection?.id === 'btnTaggingConfiguration')">
    <arc-configuration-tagging-container></arc-configuration-tagging-container>
  </aur-card>
  <aur-card *ngIf="drawerDrawn && (activeSection?.id === 'btnSenderDomainConfiguration')">
    <arc-configuration-sender-domain></arc-configuration-sender-domain>
  </aur-card>
</aur-drawer>
